import { useState,  useRef, useLayoutEffect } from "react";
import { Link } from "react-router-dom";
// --- gsap ----------------------------------------------------------------
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// --- swiper ----------------------------------------------------------------
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";
// --- lottie ----------------------------------------------------------------
import Lottie from "lottie-react";
import contactLogo from "../../assets/lotties/logo-purple.json";
// --- media ----------------------------------------------------------------
import visualHeroVideo from "../../assets/videos/visual-studio.mp4";
import visualHeroVideoMo from "../../assets/videos/visual-studio-mo.mp4";
import { 
  kakaoIcon,
  servicePortfolio07,
  servicePortfolio08,
  servicePortfolio09,
  servicePortfolio10,
  servicePortfolio11,
  servicePortfolio12,
  servicePortfolio13,
  servicePortfolio14,
  serviceVisual01,
  serviceVisual02,
  serviceVisual03,
  serviceVisual04,
  serviceVisual05,
 } from "../../assets/images";
 // --- style ----------------------------------------------------------------
 import "./Service.scss";

 gsap.registerPlugin(ScrollTrigger);

function VisualStudio() {
  // --- 데이터 ----------------------------------------------------------------
  const visualFlow = [
    {
      key: "concept",
      label: "콘셉트 상담",
      desc: "장르 · 톤 · 스토리 방향 기획",
    },    
    {
      key: "preproduction",
      label: "촬영 준비",
      desc: "장소 · 조명 · 의상 · 소품 세팅",
    },
    {
      key: "production",
      label: "본 촬영",
      desc: "감독 및 카메라 세팅",
    },
    {
      key: "postproduction",
      label: "편집 & 보정",
      desc: "컬러 · 사운드 동기화, 로고 삽입",
    },
    {
      key: "delivery",
      label: "납품 & 홍보 연동",
      desc: "SNS용 변환, 포트폴리오 업로드",
    },     
  ]  
  const [activeKey, setActiveKey] = useState(visualFlow[0].key);
  const activeItem = visualFlow.find((item) => item.key === activeKey) ?? visualFlow[0]; 

  // --- 애니메이션 ----------------------------------------------------------------
  const scopeRef = useRef(null);
  // motion 1 animation
  useLayoutEffect(() => {
    const el = scopeRef.current;
    if (!el) return;

    const ctx = gsap.context(() => {
      const cards = Array.from(el.children);


      gsap.set(cards, { autoAlpha: 0, y: 24 });

      gsap.to(cards, {
        autoAlpha: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.45,
        scrollTrigger: {
          trigger: el, 
          start: "top 75%",
          once: true,
        },
      });
    }, scopeRef);

    return () => ctx.revert();
  }, []);  

  return (
    <div className="content-section visual">
      {/* === VIDEO 영역 === */}
      <div className="home__hero visual">
        {/* PC video */}
        <video
          className="hero-video hero-video--pc"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          aria-hidden="true"
        >
          <source src={visualHeroVideo} type="video/mp4" />
        </video>

        {/* Mobile video */}
        <video
          className="hero-video hero-video--mo"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          aria-hidden="true"
        >
          <source src={visualHeroVideoMo} type="video/mp4" />
        </video>          
      </div>

      {/* === VISUAL SERVICE === */}
      <section className="visual__service max-12">
        <div className="content-section__title">
          <span>조명 아래, 당신의 순간이 기록됩니다</span>
          <h3 className="gfont">VISUAL SERVICE</h3>
        </div>
        <ul ref={scopeRef} className="service-content">
          <li>
            <img src={serviceVisual01} alt="" aria-hidden="true" />
            <div className="descrption">
              <h4>프로필 촬영</h4>
              <ul>
                <li>콘셉트 기획</li>
                <li>조명 세팅</li>
                <li>보정 10컷</li>
              </ul>
              <span>헤어 메이크업 별도</span>
              <p className="price">150,000원</p>              
            </div>
          </li>
          <li>
            <img src={serviceVisual02} alt="" aria-hidden="true" />
            <div className="descrption">
              <h4>라이브 클립</h4>
              <ul>
                <li>영상 1곡 원테이크</li>
                <li>컬러 보정</li>
                <li>4K</li>
                <li>사운드 동시 녹음</li>
              </ul>
              <p className="price">200,000원</p>
            </div>
          </li>
          <li>
            <img src={serviceVisual03} alt="" aria-hidden="true" />
            <div className="descrption">
              <h4>메이킹 필름</h4>
              <ul>
                <li>녹음·촬영 과정 브이로그</li>
                <li>SNS 홍보용</li>
              </ul>
              <p className="price">200,000원</p>
            </div>
          </li>
          <li>
            <img src={serviceVisual04} alt="" aria-hidden="true" />
            <div className="descrption">
              <h4>SNS 숏폼 제작</h4>
              <ul>
                <li>릴스 포맷 맞춤 제작</li>
                <li>세로형 9:16 비율</li>
              </ul>
              <p className="price">120,000원</p>
            </div>
          </li>
          <li>
            <img src={serviceVisual05} alt="" aria-hidden="true" />
            <div className="descrption">
              <h4>브랜딩 영상</h4>
              <ul>
                <li>브랜드·행사용 시그니처 영상</li>
                <li>기업·행사 협업 가능</li>
              </ul>
              <p className="price">300,000원</p>
            </div>          
          </li>
        </ul>
      </section>

      {/* === MOB VISUAL FLOW === */}
      <section className="soundlab__step max-12">
        <div className="content-section__title">
          <span>AI로 만든 음악, 이렇게 발매됩니다</span>
          <h3 className="gfont">MOB VISUAL FLOW</h3>
        </div>        
        <div className="step-bg oval">
          <div className="step-swiper-wrap">
            <Swiper
              className="step-swiper"
              slidesPerView="auto"
              freeMode
              modules={[FreeMode]}
              spaceBetween={12}
              touchStartPreventDefault={false}
              noSwiping={false}
            >
              {visualFlow.map((item, idx) => (
                <SwiperSlide key={item.key} style={{ width: "auto" }}>
                  <button
                    type="button"
                    className={activeKey === item.key ? "active" : ""}
                    onClick={() => setActiveKey(item.key)}
                  >
                    {item.label}
                  </button>
                </SwiperSlide>
              ))}
            </Swiper>  
          </div>  
          <div className="step-content">
            <div className="content-bg">
              <p className="desc-03">{activeItem.desc}</p>
            </div>
          </div>
        </div>    
      </section>      

      {/* === PORTFOLIO === */}
      <section className="visual__portfolio max-12">
        <div className="content-section__title">
          <span>AI로 만든 음악, 이렇게 발매됩니다</span>
          <h3 className="gfont">PORTFOLIO</h3>
        </div>

        <ul>
          <li>
            <img src={servicePortfolio07} alt="" aria-hidden="true" />
          </li>
          <li>
            <img src={servicePortfolio08} alt="" aria-hidden="true" />
          </li>
          <li>
            <img src={servicePortfolio09} alt="" aria-hidden="true" />
          </li>
          <li>
            <img src={servicePortfolio10} alt="" aria-hidden="true" />
          </li>
          <li>
            <img src={servicePortfolio11} alt="" aria-hidden="true" />
          </li>
          <li>
            <img src={servicePortfolio12} alt="" aria-hidden="true" />
          </li>
          <li>
            <img src={servicePortfolio13} alt="" aria-hidden="true" />
          </li>
          <li>
            <img src={servicePortfolio14} alt="" aria-hidden="true" />
          </li>                    
        </ul>
      </section>      

      {/* === MOB STUDIO BANNER === */}
      <section className="mob-live-studio">
        <div className="content-section__title max-12">
          <span>매 순간이 작품이 되는 스튜디오</span>
          <h3 className="gfont">MOB STUDIO</h3>
        </div>
        <div className="studio-content mob">
          <h4>
            프로의 기술로 공간 사운드를 완성합니다.
          </h4>
          <p>
            MOB STUDIO는 기술과 감성의 조화를 <br />
            당신의 음악 세계로 보냅니다
          </p>
        </div>    
      </section>

      {/* === INQUIRY === */} 
      <div className="content-section__contact">
        <p className="desc">
          ALL MAKERS, ONE STAGE. 지금 당신의 무대를 시작하세요
        </p>
        <h3 className="gfont title">
          RESERVATION INQUIRY
        </h3>
        <Lottie
          animationData={contactLogo}
          loop
          autoplay
          className="contact-lottie"
        />

        <div className="kakao-link">
          <span>지금 시작해 보세요.</span>
          <a 
          href="https://pf.kakao.com/_QLTxgn"
          target="_blank"
          rel="noopener noreferrer"
          >
            <img src={kakaoIcon} alt="" aria-hidden="true" />
            카카오 채널 문의
          </a>
        </div>
      </div>        
    </div>
  )
}

export default VisualStudio